import React from 'react';

const Footer: React.FC = () => {
  const scrollToSection = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer id="contact" className="bg-stone-900 text-stone-300 py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 bg-serchon-gold rounded-lg flex items-center justify-center text-white font-serif font-bold text-2xl">
                溯
              </div>
              <div>
                <div className="text-white font-serif font-bold text-xl">溯玄科技</div>
                <div className="text-sm text-stone-500">Serchon Technology</div>
              </div>
            </div>
            <p className="text-stone-400 leading-relaxed mb-6 max-w-md">
              江西溯玄科技有限公司是一家专注于人工智能应用软件开发、数据处理服务、软件外包服务等领域的高新技术企业。
            </p>
            <div className="text-sm text-stone-500">
              <p className="mb-2">成立于 2025 年 09 月 30 日</p>
              <p>致力于为客户提供卓越的技术服务</p>
            </div>
          </div>

          <div>
            <h3 className="text-white font-serif font-bold text-lg mb-4">快速链接</h3>
            <ul className="space-y-3">
              <li>
                <a href="#home" onClick={scrollToSection('home')} className="hover:text-serchon-gold transition-colors">
                  首页
                </a>
              </li>
              <li>
                <a href="#about" onClick={scrollToSection('about')} className="hover:text-serchon-gold transition-colors">
                  关于我们
                </a>
              </li>
              <li>
                <a href="#services" onClick={scrollToSection('services')} className="hover:text-serchon-gold transition-colors">
                  服务领域
                </a>
              </li>
              <li>
                <a href="#technology" onClick={scrollToSection('technology')} className="hover:text-serchon-gold transition-colors">
                  核心技术
                </a>
              </li>
              <li>
                <a href="#advantage" onClick={scrollToSection('advantage')} className="hover:text-serchon-gold transition-colors">
                  核心优势
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-serif font-bold text-lg mb-4">联系我们</h3>
            <ul className="space-y-3 text-stone-400">
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-serchon-gold rounded-full"></span>
                江西省南昌市
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-serchon-gold rounded-full"></span>
                xuxuan@serchon.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-serchon-gold rounded-full"></span>
                服务热线：18720140052
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-stone-500">
            © 2025 江西溯玄科技有限公司. 保留所有权利.
          </div>
          <div className="text-sm text-stone-600">
            人工智能 • 软件开发 • 数据处理 • 信息技术咨询
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
